<template>
    <div id="appContractReports">
        <div class="c-subheader">
            <h5 id="headerContract"></h5>
        </div>
        <ejs-tab id="element" :selectedItem="selectedItem" ref=contractReportTabs>
            <e-tabitems>
                <e-tabitem :header='headerText0' :content='PositionReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText1' :content='M2MReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText9' :content='VolumeReportTemplate'></e-tabitem> 
                <e-tabitem :header='headerText3' :content='CostAndPricingReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :content='ContractAlertsReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText5' :content='HedgingOverviewReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText6' :content='TicketsReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText8' :content='TicketsLogsReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText7' :content='hypotheticalTradesTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
        <!--<ejs-toast ref='toastrRef' id='contractToast' :position='position'></ejs-toast>-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import PositionReport from '@/views/templates/PositionReportTemplate.vue';
    import M2MReportTemplate from '@/views/templates/M2MReportTemplate.vue';
    import VolumeReportTemplate from '@/views/templates/VolumeReportTemplate.vue';
    import CostAndPricingReportTemplate from '@/views/templates/CostAndPricingReportTemplate.vue';
    import ContractAlertsReportTemplate from '@/views/templates/ContractAlertsReportTemplate.vue';
    import TicketsReportTemplate from '@/views/templates/TicketsReportTemplate.vue';
    import HedgingOverviewReportTemplate from '@/views/templates/HedgingOverviewReportTemplate.vue';
    import HypotheticalTrades from '@/views/templates/HypotheticalTradeReportTemplate.vue';
    import TicketsLogsReportTemplate from '@/views/templates/TicketsLogsReportTemplate.vue';
    import urls from '../../common/urls';
    import apis from '../../common/network';

    Vue.use(TabPlugin);
    export default {
        name: 'ContractReportTabs',
        created() {
            this.$store.commit('setReportsContractId', this.$route.params.contractId);
            this.fetchData(this.$route.params.contractId);
            this.fetchContract(this.$route.params.contractId);

        },
        data: function () {
            return {
                headerText0: { text: 'Position Summary' },
                headerText1: { text: 'M2M' },
                headerText3: { text: 'Contract Performance' },
                headerText5: { text: 'Hedging Overview' },
                headerText6: { text: 'Trades' },
                headerText7: { text: 'Hypothetical Trades' },
                headerText8: { text: 'Trades Logs' },
                headerText9: { text: 'Volume Report' },
                position: { X: 'Right', Y: 'Bottom' },
                propsData: null,
                selectedItem: this.$route.params.callerTab == "hypothetical" ? 8 : this.$route.params.callerTab == "Trades"? 6: 0,
                deadline: 0,
                status: 0,
                hit: 0,
                AlertsCount:0,
                PositionReportTemplate: function () {
                    return {
                        template: {
                            extends: PositionReport
                        }
                    };
                },
                M2MReportTemplate: function () {
                    return {
                        template: {
                            extends: M2MReportTemplate
                        }
                    }
                },
                VolumeReportTemplate: function () {
                    return {
                        template: {
                            extends: VolumeReportTemplate
                        }
                    }
                },
                CostAndPricingReportTemplate: function () {
                    return {
                        template: {
                            extends: CostAndPricingReportTemplate
                        }
                    }
                },
                ContractAlertsReportTemplate: function () {
                    return {
                        template: {
                            extends: ContractAlertsReportTemplate
                        }
                    }
                },
                HedgingOverviewReportTemplate: function () {
                    return {
                        template: {
                            extends: HedgingOverviewReportTemplate
                        }
                    }
                },
                TicketsReportTemplate: function () {
                    return {
                        template: {
                            extends: TicketsReportTemplate
                        }
                    }
                },
                hypotheticalTradesTemplate: function () {
                    return {
                        template: {
                            extends: HypotheticalTrades
                        }
                    }
                },
                TicketsLogsReportTemplate: function () {
                    return {
                        template: {
                            extends: TicketsLogsReportTemplate
                        }
                    }
                }
            }
        },
        methods: {
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts?contractId=${id}`).then(it => {
                    this.deadline = it.data.deadline;
                    this.status = it.data.status;
                    this.hit = it.data.hit;
                    this.AlertsCount = this.hit + this.deadline + this.status;
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );

            },

            fetchContract(id) {
                apis.protectedApi.get(`contract/getContractName?contractId=${id}`)
                    .then(response => {

                        this.contractName = response.data.contractName;
                        document.getElementById('headerContract').textContent = this.contractName;

                    }).catch(response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                 );
            }
        },
        computed: {
            headerText4() {
                return { text: "Alerts (" + this.AlertsCount +")"};
            },
        },
    }
</script>

<style scoped>
</style>


<style>
    #headerContract {
        color: #8a93a2;
        margin-top: 10px;
        margin-left: 11px;
    }
</style>